import { defaultColumns, defaultSort } from '../../components/data/storages/columns';

export default {
  state: {
    storages: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    storages: state => state.storages,
    ownStorages: state => state.storages.filter(s => s.type === 'own').sort((a, b) => a.id - b.id),
    representativeStorages: state => state.storages.filter(s => s.type === 'representative').sort((a, b) => a.id - b.id),
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setStorages(state, storages) {
      state.storages = storages;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/storage-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'storage-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'storage-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const storages = await axios.get('api/storages' + (query || ''));
        commit('setStorages', storages);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/storages/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/storages', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/storages', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/storages/${id}`);
    },
  },
};
